// Module
var code = "<nlg-carrier-zone> <div panel=carrierZone.edition.details> <div class=row> <div class=\"col-xs-6 col-sm-3\"> <label translate>carrierZone.edition.priority</label> <nlg-number-input name=entity.priority ng-model=entity.priority nlg-decimals=0 min=0 max=100000> </nlg-number-input> </div> </div> </div> </nlg-carrier-zone>";
// Exports
module.exports = code;